// todo this should be removed once updated in calculation
export enum RolloverPrecisePropertyTypeEnum {
  mineralAsset = 'MINERAL_ASSET',
  debtObligations = 'DEBT_OBLIGATIONS',
  specificDebtObligations = 'SPECIFIC_DEBT_OBLIGATIONS',
  capitalPropertyThatIsRealPropertyOwnedByNonResident = 'CAPITAL_PROPERTY_THAT_IS_REAL_PROPERTY_OWNED_BY_NON_RESIDENT',
  agriInvestment = 'AGRI_INVESTMENT',
  other = 'OTHER',
}
